'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (styles, options) {
  return options && options.themeStyles ? _extends({}, styles, options.themeStyles) : styles;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/styles.js
// module id = 803
// module chunks = 0